export default __webpack_public_path__ + "static/media/logo-twitter.4eb63e01.svg";